import { apiFetch } from '../lib/api';
import type { UserSearchResult } from '../types/api';
import type { components } from '../types/api';

type UserProfile = components['schemas']['UserProfileResponse'];
type UpdateProfileRequest = components['schemas']['UpdateProfileRequest'];

export function searchUsers(q: string): Promise<UserSearchResult[]> {
  return apiFetch<UserSearchResult[]>(`/api/users/search?q=${encodeURIComponent(q)}`);
}

export function updateMyProfile(req: UpdateProfileRequest): Promise<UserProfile> {
  return apiFetch<UserProfile>('/api/users/me', { method: 'PUT', body: req });
}
